module.exports = __webpack_public_path__ + "web/img/bg2.abcb9f59.png";